import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ToastState {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
  duration: number;
}

const initialState: ToastState = {
  open: false,
  message: '',
  severity: 'info',
  duration: 5000,
};

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast(
      state,
      action: PayloadAction<{
        message: string;
        severity?: ToastState['severity'];
        duration?: number;
      }>,
    ) {
      state.open = true;
      state.message = action.payload.message;
      state.severity = action.payload.severity ?? 'info';
      state.duration = action.payload.duration ?? 5000;
    },
    dismissToast(state) {
      state.open = false;
    },
  },
});

export const { showToast, dismissToast } = toastSlice.actions;
export default toastSlice.reducer;
